<template>
	<div v-loading="loading" element-loading-text="下载中,请稍后" element-loading-spinner="el-icon-loading">
		<el-row>
			<el-row :gutter="15">
				<el-col :xs="24" :sm="8" :md="8">
					<el-input v-model="keywords" size="mini" placeholder="输入关键字搜索" maxlength="30" clearable
						style="margin:5px" @clear="fetchData">
						<el-button slot="append" icon="el-icon-search" @click="fetchData"></el-button>
					</el-input>
				</el-col>
				<el-col :xs="24" :sm="8" :md="8" style="margin-bottom: 20px;">
					<!-- <el-tooltip content="请先点击左侧医院列表" placement="right" effect="light"> -->
					<el-button style="margin: 5px;" size="mini" type="success" @click="openDialog()"
						:disabled="$route.query.id == undefined">新增招投标记录</el-button>
					<!-- 					</el-tooltip> -->
				</el-col>
			</el-row>
			<el-table :data="tableData" stripe size="large" style="width: 100%" row-key="id">
				<!-- 展开行 -->
				<el-table-column type="expand">
					<template slot-scope="scope">
						<div class="expand-wrapper">
							<el-tabs tab-position="top">

								<!-- ================= 基本信息 ================= -->
								<el-tab-pane label="基本信息">
									<el-card shadow="never" class="card">
										<el-descriptions :column="2" border size="medium">
											<el-descriptions-item label="所属科室">
												{{ scope.row.tender_dept }}
											</el-descriptions-item>
											<el-descriptions-item label="开始时间">
												{{ formatDate(scope.row.start_date) }}
											</el-descriptions-item>
											<el-descriptions-item label="招标方式">
												<el-tag type="danger">{{ scope.row.tender_method }}</el-tag>
											</el-descriptions-item>
											<el-descriptions-item label="结束时间">
												{{ formatDate(scope.row.end_date) }}
											</el-descriptions-item>
											<el-descriptions-item label="招标背景">
												{{ scope.row.tender_background }}
											</el-descriptions-item>
										</el-descriptions>
									</el-card>
								</el-tab-pane>

								<el-tab-pane label="影响因素">
									<el-card shadow="never" class="card">
										<el-descriptions :column="2" border size="medium">

											<el-descriptions-item label="价格/技术/商务占比">
												{{ scope.row.score_ratio }}
											</el-descriptions-item>

											<el-descriptions-item label="关键决策者">
												{{ scope.row.key_decision_makers }}
											</el-descriptions-item>

											<el-descriptions-item label="客情关系状态">
												{{ scope.row.client_relationship_status }}
											</el-descriptions-item>

											<el-descriptions-item label="参数引导">
												<el-tag :type="scope.row.has_parameter_guidance ? 'success' : 'danger'">
													{{ scope.row.has_parameter_guidance ? '是' : '否' }}
												</el-tag>
											</el-descriptions-item>

											<el-descriptions-item label="主要竞争对手">
												<el-tag v-for="item in splitList(scope.row.main_competitors)"
													:key="item" style="margin-right:4px" size="mini">
													{{ item }}
												</el-tag>
											</el-descriptions-item>
										</el-descriptions>
									</el-card>
								</el-tab-pane>

								<!-- ================= 招标产品 ================= -->
								<el-tab-pane label="招标产品">
									<el-table :data="scope.row.tender_products" border stripe size="large"
										max-height="320">
										<el-table-column label="品名" prop="tender_product" show-overflow-tooltip />
										<el-table-column label="规格" prop="tender_spec" />
										<el-table-column label="价格(元)" prop="tender_price" align="right" />

										<el-table-column label="更新时间">
											<template slot-scope="scope">
												{{ formatDate(scope.row.update_date) }}
											</template>
										</el-table-column>

										<el-table-column label="变更记录" width="100" align="center">
											<template slot-scope="scope">
												<el-button type="text" size="mini"
													@click="showHistoryTenderProduct(scope.row.id)">
													查看
												</el-button>
											</template>
										</el-table-column>
									</el-table>
								</el-tab-pane>

								<!-- ================= 投标信息 ================= -->
								<el-tab-pane label="投标及中标信息">
									<el-table :data="scope.row.tender_bids" border stripe size="large" max-height="320">
										<el-table-column label="投标公司" prop="bid_company" />
										<el-table-column label="品牌" prop="bid_brand" />
										<el-table-column label="品名" prop="bid_product_name" show-overflow-tooltip />
										<el-table-column label="规格" prop="bid_spec" />
										<el-table-column label="配比" prop="bid_dilution" />

										<el-table-column label="投标价格" prop="bid_price" align="right" />

										<el-table-column label="是否中标">
											<template slot-scope="scope">
												<el-tag :type="scope.row.is_win ? 'success' : 'warning'">
													{{ scope.row.is_win ? '中标' : '未中标' }}
												</el-tag>
											</template>
										</el-table-column>

										<el-table-column label="中标价格(元)" prop="win_price" align="right" />

										<el-table-column label="供货效期" prop="supply_expire" />

										<!-- <el-table-column label="备注" prop="remark" show-overflow-tooltip /> -->

										<el-table-column label="更新时间">
											<template slot-scope="scope">
												{{ formatDate(scope.row.update_date) }}
											</template>
										</el-table-column>

										<el-table-column label="变更记录" width="100" align="center">
											<template slot-scope="scope">
												<el-button type="text" size="mini"
													@click="showHistoryTenderBid(scope.row.id)">
													查看
												</el-button>
											</template>
										</el-table-column>

									</el-table>
								</el-tab-pane>

								<!-- ================= 复盘总结 ================= -->
								<el-tab-pane label="复盘总结">
									<el-card shadow="never">
										<el-descriptions :column="1" border size="medium">
											<el-descriptions-item label="中标/丢标核心原因">
												{{ scope.row.tender_result_core_reason }}
											</el-descriptions-item>
											<el-descriptions-item label="后续跟进动作">
												{{ scope.row.follow_up_actions }}
											</el-descriptions-item>
											<el-descriptions-item label="备注">
												{{ scope.row.tender_remark }}
											</el-descriptions-item>
										</el-descriptions>
									</el-card>
								</el-tab-pane>
							</el-tabs>

						</div>
					</template>
				</el-table-column>

				<!-- ================= 主表 ================= -->
				<el-table-column label="招标科室" prop="tender_dept" sortable />
				<el-table-column label="招标方式" prop="tender_method" sortable />
				<el-table-column label="开始日期" prop="start_date" sortable />
				<el-table-column label="结束日期" prop="end_date" sortable />
				<el-table-column label="填报人" prop="tender_user__person_name" />

				<el-table-column label="最后更新">
					<template slot-scope="scope">
						{{ formatDate(scope.row.update_date) }}
					</template>
				</el-table-column>

				<el-table-column label="变更记录" align="center" width="100">
					<template slot-scope="scope">
						<el-button type="text" size="mini" @click="showHistoryTender(scope.row.id)">
							查看
						</el-button>
					</template>
				</el-table-column>

				<el-table-column label="操作" width="160" align="center">
					<template slot-scope="scope">
						<el-button-group>
							<el-button size="mini" icon="el-icon-edit" @click="openDialog(scope.row)">
								改
							</el-button>
							<el-button size="mini" type="danger" icon="el-icon-delete" @click="deleteData(scope.row)">
								删
							</el-button>
						</el-button-group>
					</template>
				</el-table-column>

			</el-table>

			<!-- 分页 -->
			<el-row class="paginator hidden-sm-and-down">
				<el-pagination background :current-page.sync="currentPage" layout="total, sizes, prev, pager, next"
					:total="total" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
					@current-change="handleCurrentChange" @size-change="handleSizeChange" />
			</el-row>

			<el-row class="paginator hidden-sm-and-up">
				<el-pagination background :current-page.sync="currentPage" layout="prev, pager, next" :total="total"
					:page-size="pageSize" @current-change="handleCurrentChange" @size-change="handleSizeChange"
					prev-text="上一页" next-text="下一页" :pager-count="5" />
			</el-row>
			<!-- </el-card> -->
		</el-row>

		<!-- 数据处理表单 -->
		<el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :close-on-click-modal="false"
			:close-on-press-escape="false" :show-close="false" :width="'60%'" :fullscreen="ifFullScreen">
			<el-form ref="form" :rules="rules" :model="formData" :label-width="formLabelWidth" size="small">

				<!-- 基础信息 -->
				<el-row :gutter="10">
					<h3 style="margin:10px 0">基本信息</h3>
					<el-col :sm="8" :xs="24">
						<el-form-item label="招标科室" prop="tender_dept">
							<el-select v-model="formData.tender_dept" filterable default-first-option>
								<el-option v-for="item in tenderDeptOptions" :key="item.value" :label="item.label"
									:value="item.value" />
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :sm="8" :xs="24">
						<el-form-item label="招标背景" prop="tender_background">
							<el-select v-model="formData.tender_background" filterable default-first-option>
								<el-option v-for="item in tenderBackgroundOptions" :key="item.value" :label="item.label"
									:value="item.value" />
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :sm="8" :xs="24">
						<el-form-item label="招标方式" prop="tender_method">
							<el-select v-model="formData.tender_method" filterable default-first-option>
								<el-option v-for="item in tenderMethodOptions" :key="item.value" :label="item.label"
									:value="item.value" />
							</el-select>
						</el-form-item>
					</el-col>

					<el-col :sm="8" :xs="24">
						<el-form-item label="开始日期" prop="start_date">
							<el-date-picker v-model="formData.start_date" type="date" value-format="yyyy-MM-dd" />
						</el-form-item>
					</el-col>

					<el-col :sm="8" :xs="24">
						<el-form-item label="结束日期" prop="end_date">
							<el-date-picker v-model="formData.end_date" type="date" value-format="yyyy-MM-dd" />
						</el-form-item>
					</el-col>
				</el-row>

				<el-row :gutter="10">
					<h3 style="margin:10px 0">招标影响因素</h3>
					<el-col :sm="14" :xs="24">
						<el-form-item label="价格分/技术分/商务分占比" prop="score_ratio" label-width="240px">
							<el-input v-model="formData.score_ratio" />
						</el-form-item>
					</el-col>
					<el-col :sm="10" :xs="24">
						<el-form-item label="是否介入参数引导" prop="has_parameter_guidance">
							<el-select v-model="formData.has_parameter_guidance" filterable default-first-option>
								<el-option v-for="item in isTrueOptions" :key="item.value" :label="item.label"
									:value="item.value" />
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :sm="12" :xs="24">
						<el-form-item label="关键决策者" prop="key_decision_makers">
							<el-input v-model="formData.key_decision_makers" />
						</el-form-item>
					</el-col>
					<el-col :sm="12" :xs="24">
						<el-form-item label="客情关系状态" prop="client_relationship_status">
							<el-select v-model="formData.client_relationship_status" filterable default-first-option>
								<el-option v-for="item in relationshipOptions" :key="item.value" :label="item.label"
									:value="item.value" />
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :sm="12" :xs="24">
						<el-form-item label="主要竞争对手" prop="main_competitors">
							<el-input v-model="formData.main_competitors" />
						</el-form-item>
					</el-col>
				</el-row>

				<el-row :gutter="10">
					<h3 style="margin:10px 0">复盘及经验总结</h3>

					<el-col :sm="12" :xs="24">
						<el-form-item label="中标/丢标核心原因" prop="tender_result_core_reason">
							<el-input v-model="formData.tender_result_core_reason" type="textarea" maxlength="500"
								show-word-limit autosize />
						</el-form-item>
					</el-col>
					<el-col :sm="12" :xs="24">
						<el-form-item label="后续跟进动作" prop="follow_up_actions">
							<el-input v-model="formData.follow_up_actions" type="textarea" maxlength="500"
								show-word-limit autosize />
						</el-form-item>
					</el-col>
					<el-col :sm="12" :xs="24">
						<el-form-item label="备注" prop="tender_remark">
							<el-input v-model="formData.tender_remark" type="textarea" maxlength="500" show-word-limit
								autosize />
						</el-form-item>
					</el-col>
				</el-row>

				<el-row :gutter="20">
					<!-- 招标产品 -->
					<el-col :sm="12" :xs="24">
						<h3 style="margin:10px 0">招标产品</h3>
						<div v-for="(product, index) in formData.tender_products" :key="'product-' + index">
							<el-card shadow="never" style="margin-bottom:10px">

								<el-form-item label="产品名称" :prop="`tender_products.${index}.tender_product`"
									:rules="{ required: true, message: '必填', trigger: 'blur' }">
									<el-input v-model="product.tender_product" />
								</el-form-item>

								<el-form-item label="规格" :prop="`tender_products.${index}.tender_spec`">
									<el-input v-model="product.tender_spec" />
								</el-form-item>

								<el-form-item label="招标价（元）" :prop="`tender_products.${index}.tender_price`">
									<el-input-number v-model="product.tender_price" :min="0" :precision="2" />
								</el-form-item>

								<el-button type="danger" size="mini" @click="removeProduct(index)">
									删除
								</el-button>
							</el-card>
						</div>

						<el-button type="primary" size="small" icon="el-icon-plus" @click="addProduct">
							新增招标产品
						</el-button>
					</el-col>

					<!-- 投标记录 -->
					<el-col :sm="12" :xs="24">
						<h3 style="margin:10px 0">投标记录</h3>
						<div v-for="(bid, index) in formData.tender_bids" :key="'bid-' + index">
							<el-card shadow="never" style="margin-bottom:10px">
								<el-form-item label="投标公司" :prop="`tender_bids.${index}.bid_company`"
									:rules="{ required: true, message: '必填', trigger: 'blur' }">
									<el-input v-model="bid.bid_company" />
								</el-form-item>

								<el-form-item label="品牌" :prop="`tender_bids.${index}.bid_brand`"
									:rules="{ required: true, message: '必填', trigger: 'blur' }">
									<el-input v-model="bid.bid_brand" />
								</el-form-item>

								<el-form-item label="产品名称" :prop="`tender_bids.${index}.bid_product_name`"
									:rules="{ required: true, message: '必填', trigger: 'blur' }">
									<el-input v-model="bid.bid_product_name" />
								</el-form-item>

								<el-form-item label="规格" :prop="`tender_bids.${index}.bid_spec`">
									<el-input v-model="bid.bid_spec" />
								</el-form-item>

								<el-form-item label="配比" :prop="`tender_bids.${index}.bid_dilution`">
									<el-input v-model="bid.bid_dilution" />
								</el-form-item>

								<el-form-item label="投标价（元）" :prop="`tender_bids.${index}.bid_price`">
									<el-input-number v-model="bid.bid_price" :min="0" :max="9999" :precision="2" />
								</el-form-item>

								<el-form-item label="是否中标" :prop="`tender_bids.${index}.is_win`"
									:rules="{ required: true, message: '必填', trigger: 'blur' }">
									<el-select v-model="bid.is_win">
										<el-option v-for="item in isTrueOptions" :key="item.value" :label="item.label"
											:value="item.value" />
									</el-select>
								</el-form-item>

								<el-form-item label="中标价（元）" :prop="`tender_bids.${index}.win_price`">
									<el-input-number v-model="bid.win_price" :min="0" :max="9999" :precision="2" />
								</el-form-item>

								<el-form-item label="供货效期">
									<el-input v-model="bid.supply_expire" />
								</el-form-item>

<!-- 								<el-form-item label="备注">
									<el-input v-model="bid.remark" type="textarea" maxlength="100" show-word-limit
										autosize />
								</el-form-item> -->

								<el-button type="danger" size="mini" @click="removeBid(index)">
									删除
								</el-button>
								<el-button type="success" size="mini" @click="duplicateBid(index)">
									复制
								</el-button>
							</el-card>
						</div>

						<el-button type="primary" size="small" icon="el-icon-plus" @click="addBid">
							新增投标记录
						</el-button>

					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="resetForm('form')">取 消</el-button>
				<el-button type="danger" @click="saveData">提 交</el-button>
			</div>
		</el-dialog>

		<!-- 历史记录弹窗1 -->
		<el-dialog title="招标计划历史记录" :visible.sync="dialogHistoryTenderVisible" :width="'80%'"
			:fullscreen="ifFullScreen">
			<el-table :data="tableHistoryTenderData">
				<el-table-column label="操作时间" prop="history_date" sortable />
				<el-table-column label="操作" prop="history_type" />
				<el-table-column label="操作人" prop="tender_user" />
				<el-table-column label="数据">
					<el-table-column label="招标方式" prop="tender_method" />
					<el-table-column label="开始时间" prop="start_date" />
					<el-table-column label="结束时间" prop="end_date" />
				</el-table-column>
			</el-table>
		</el-dialog>

		<!-- 历史记录弹窗 2-->
		<el-dialog title="招标产品历史记录" :visible.sync="dialogHistoryTenderProductsVisible" :width="'80%'"
			:fullscreen="ifFullScreen">
			<el-table :data="tableHistoryTenderProductsData">
				<el-table-column label="操作时间" prop="history_date" sortable />
				<el-table-column label="操作" prop="history_type" />
				<el-table-column label="操作人" prop="tender_product_user" sortable />
				<el-table-column label="数据">
					<el-table-column label="招标产品" prop="tender_product" />
					<el-table-column label="招标规格" prop="tender_spec" />
					<el-table-column label="招标价格(元)" prop="tender_price" />
				</el-table-column>
			</el-table>
		</el-dialog>

		<!-- 历史记录弹窗 3-->
		<el-dialog title="投标及中标历史记录" :visible.sync="dialogHistoryTenderBidsVisible" :width="'80%'"
			:fullscreen="ifFullScreen">
			<el-table :data="tableHistoryTenderBidsData">
				<el-table-column label="操作时间" prop="history_date" sortable />
				<el-table-column label="操作" prop="history_type" />
				<el-table-column label="操作人" prop="bid_user" sortable />
				<el-table-column label="数据">
					<el-table-column label="投标公司" prop="bid_company" />
					<el-table-column label="品牌" prop="bid_brand" />
					<el-table-column label="品名" prop="bid_product_name" show-overflow-tooltip />
					<el-table-column label="规格" prop="bid_spec" />
					<el-table-column label="配比" prop="bid_dilution" />
					<el-table-column label="投标价格" prop="bid_price" />
					<el-table-column label="是否中标" prop="is_win">
						<template slot-scope="scope">
							{{scope.row.is_win == true ? "是" :"否"}}
						</template>
					</el-table-column>
					<el-table-column label="中标价格(元)" prop="win_price" />
					<el-table-column label="供货效期" prop="supply_expire" />
					<el-table-column label="备注" prop="remark" />
				</el-table-column>
			</el-table>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		inject: ['reload', 'logout'],
		data() {
			return {
				tableData: [],
				tableHistoryTenderData: [],
				tableHistoryTenderProductsData: [],
				tableHistoryTenderBidsData: [],
				keywords: '',
				dialogVisible: false,
				dialogHistoryTenderProductsVisible: false,
				dialogHistoryTenderBidsVisible: false,
				dialogHistoryTenderVisible: false,
				ifFullScreen: false,
				optionLoading: false,
				isTrueOptions: [{
						label: "是",
						value: true
					},
					{
						label: "否",
						value: false
					},
				],
				formData: {
					id: null,
					tender_dept: '',
					tender_method: '',
					start_date: '',
					end_date: '',
					tender_background: '',
					score_ratio: '',
					key_decision_makers: '',
					client_relationship_status: '',
					has_parameter_guidance: '',
					main_competitors: '',
					tender_result_core_reason: '',
					follow_up_actions: '',
					tender_remark: '',
					tender_products: [{
						id: '',
						tender_product: '',
						tender_spec: '',
						tender_price: 0,
					}],
					tender_bids: [{
						id: '',
						bid_company: '',
						bid_brand: '',
						bid_product_name: '',
						bid_spec: '',
						bid_dilution: '',
						bid_price: 0,
						is_win: '',
						win_price: 0,
						supply_expire: '',
						// remark: ''
					}],
					hospital_id: null
				},
				tenderMethodOptions: [{
						value: '院内',
						label: '院内'
					},
					{
						value: '第三方',
						label: '第三方'
					},
					{
						value: '其他',
						label: '其他'
					}
				],
				tenderDeptOptions: [{
						value: 'CSSD',
						label: 'CSSD'
					},
					{
						value: '内镜中心',
						label: '内镜中心'
					},
					{
						value: '其他',
						label: '其他'
					}
				],
				tenderBackgroundOptions: [{
						value: '正常招标',
						label: '正常招标'
					},
					{
						value: '竞争对手发起',
						label: '竞争对手发起'
					},
					{
						value: '其他',
						label: '其他'
					}
				],
				relationshipOptions: [{
						value: '极佳',
						label: '极佳'
					},
					{
						value: '良好',
						label: '良好'
					},
					{
						value: '一般',
						label: '一般'
					},
					{
						value: '较差',
						label: '较差'
					}
				],
				//新增和更新表单的验证规则
				rules: {
					tender_method: [{
						required: true,
						message: '请选择招标类型',
						trigger: 'change'
					}],
					start_date: [{
						required: true,
						message: '请选择开始日期',
						trigger: 'change'
					}],
					end_date: [{
						required: true,
						message: '请选择结束日期',
						trigger: 'change'
					}],
					tender_dept: [{
						required: true,
						message: '请选择招标科室',
						trigger: 'change'
					}],
					tender_background: [{
						required: true,
						message: '请选择招标背景',
						trigger: 'change'
					}],
					score_ratio: [{
						required: true,
						message: '请填写',
						trigger: 'change'
					}],
					key_decision_makers: [{
						required: true,
						message: '请填写',
						trigger: 'change'
					}],
					client_relationship_status: [{
						required: true,
						message: '请填写',
						trigger: 'change'
					}],
					has_parameter_guidance: [{
						required: true,
						message: '请填写',
						trigger: 'change'
					}],
					main_competitors: [{
						required: true,
						message: '请填写',
						trigger: 'change'
					}],


				},
				dialogTitle: "新增数据",
				formLabelWidth: '140px',
				total: 100,
				currentPage: 1,
				pageSize: 20,
				loading: false,
				hospital_id: this.$route.query.id
			};
		},
		methods: {
			formatDate(val) {
				if (!val) return ''
				return val.split('.')[0].replace('T', ' ')
			},

			splitList(val) {
				if (!val) return []
				return String(val).split(',').filter(Boolean)
			},

			addProduct() {
				this.formData.tender_products.push({
					id: '',
					tender_product: '',
					tender_spec: '',
					tender_price: 0
				})
			},

			removeProduct(index) {
				this.formData.tender_products.splice(index, 1)
			},

			addBid() {
				this.formData.tender_bids.push({
					id: '',
					bid_company: '',
					bid_brand: '',
					bid_product_name: '',
					bid_spec: '',
					bid_dilution: '',
					bid_price: 0,
					is_win: false,
					win_price: 0,
					supply_expire: '',
					// remark: ''
				})
			},
			// 删除
			removeBid(index) {
				this.formData.tender_bids.splice(index, 1)
			},
			// 复制记录
			duplicateBid(index) {
				if (this.formData.tender_bids.length > 0) {
					const current_data = this.formData.tender_bids[index];
					current_data.id = '';
					this.formData.tender_bids.push(current_data);
				}
			},
			// 重置表单
			resetForm(formName) {
				this.$refs[formName].resetFields();
				this.dialogVisible = false;
			},
			// 获取数据
			fetchData() {
				let that = this;
				this.loading = true;
				this.$axios.get('/apim/retrieve/tender/', {
					params: {
						keywords: that.keywords,
						page: that.currentPage,
						pagesize: that.pageSize,
						hospital_id: that.hospital_id
					}
				}).then(response => {
					if (response.data.code == '401') {
						that.logout();
					}
					if (response.data.data) {
						this.tableData = response.data.data;
						this.total = response.data.totalItemNum;
					} else {
						that.$message({
							message: response.errors,
							type: 'warning',
							onClose: function() {
								that.loading = false;
							}
						});
					}
				}).finally(() => {
					this.loading = false;
				});
			},
			handleSizeChange(val) {
				this.pageSize = val;
				this.fetchData();
			},
			handleCurrentChange(val) {
				this.currentPage = val;
				this.fetchData();
			},
			//打开数据操作弹窗
			openDialog(row = null) {
				let that = this;
				this.dialogVisible = true;
				this.$nextTick(() => {
					this.$refs.form.clearValidate();
				});

				if (row) {
					this.dialogTitle = '修改招投标使用记录';
					this.formData = {
						...row,
					};
				} else {
					this.dialogTitle = '新增招投标使用记录';
					this.formData = {
						id: null,
						tender_dept: '',
						tender_method: '',
						start_date: '',
						end_date: '',
						tender_background: '',
						score_ratio: '',
						key_decision_makers: '',
						client_relationship_status: '',
						has_parameter_guidance: '',
						main_competitors: '',
						tender_result_core_reason: '',
						follow_up_actions: '',
						tender_remark: '',
						tender_products: [{
							id: '',
							tender_product: '',
							tender_spec: '',
							tender_price: 0,
						}],
						tender_bids: [{
							id: '',
							bid_company: '',
							bid_brand: '',
							bid_product_name: '',
							bid_spec: '',
							bid_dilution: '',
							bid_price: 0,
							is_win: false,
							win_price: 0,
							supply_expire: '',
							// remark: ''
						}],
						hospital_id: that.hospital_id
					};
				}
			},
			// 查看招标计划历史记录
			showHistoryTender(id) {
				let that = this;
				this.dialogHistoryTenderVisible = true;
				this.$axios.get('/apim/history/tender/', {
					params: {
						id: id,
					}
				}).then(response => {
					if (response.data.history_data) {
						this.tableHistoryTenderData = response.data.history_data;
					} else {
						that.$message({
							message: response.data.errors,
							type: 'warning',
						});
					}
				}).finally(() => {

				});
			},
			// 查看招标产品历史记录
			showHistoryTenderProduct(id) {
				let that = this;
				this.dialogHistoryTenderProductsVisible = true;
				this.$axios.get('/apim/history/tender_products/', {
					params: {
						id: id,
					}
				}).then(response => {
					if (response.data.history_data) {
						this.tableHistoryTenderProductsData = response.data.history_data;
					} else {
						that.$message({
							message: response.data.errors,
							type: 'warning',
						});
					}
				}).finally(() => {

				});
			},
			// 查看投标中标历史记录
			showHistoryTenderBid(id) {
				let that = this;
				this.dialogHistoryTenderBidsVisible = true;
				this.$axios.get('/apim/history/tender_bids/', {
					params: {
						id: id,
					}
				}).then(response => {
					if (response.data.history_data) {
						this.tableHistoryTenderBidsData = response.data.history_data;
					} else {
						that.$message({
							message: response.data.errors,
							type: 'warning',
						});
					}
				}).finally(() => {

				});
			},
			//保存记录
			saveData() {
				let that = this;
				this.$refs.form.validate((valid) => {
					if (valid) {
						const url = this.formData.id ?
							'/apim/update/tender/' : '/apim/create/tender/';
						let fd = new FormData();
						let formData = that.formData;
						console.log(this.formData)
						//添加表单数据
						for (let key in formData) {
							fd.append(key, formData[key]);
						}
						fd.set('tender_products', JSON.stringify(formData.tender_products))
						fd.set('tender_bids', JSON.stringify(formData.tender_bids))

						this.$axios({
								url: url,
								method: 'post',
								data: fd,
								headers: {
									'Content-Type': 'multipart/form-data'
								}
							})
							.then(response => {
								if (response.data.code == '200') {
									this.dialogVisible = false;
									this.fetchData();
								} else {
									that.$message({
										message: response.data.message,
										type: 'warning',
									});
								}
							})
							.catch(error => {
								that.$message({
									message: '保存失败，服务器错误',
									type: 'warning',
								});
							});
					}
				});
			},
			// 单个删除
			deleteData(row) {
				this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
					.then(() => {
						let that = this;
						let fd = new FormData();
						fd.append('id', row.id);
						this.$axios({
								url: '/apim/delete/tender/',
								method: 'post',
								data: fd,
								headers: {
									'Content-Type': 'multipart/form-data'
								}
							})
							.then(function(res) {
								if (res.data.code == '200') {
									that.fetchData();
								} else {
									that.$message({
										message: res.data.message,
										type: 'warning'
									});
								}
							})
							.catch(function(error) {
								console.log(error);
							});
					})
					.catch(() => {});
			},
		},
		mounted() {
			this.fetchData();
			this.ifFullScreen = document.body.clientWidth > 720 ? false : true;
		}
	};
</script>

<style>
.expand-wrapper {
  padding: 12px;
  background: #f5f7fa;
}

.card {
  margin-bottom: 10px;
  border-radius: 8px;
}

.el-table .cell {
  white-space: nowrap;
}
</style>